import { Card, CardContent } from "ui/components/card";
import { PLUS } from "icons";
import classNames from "classnames";
import { Button } from "ui/index";
import { Link } from "react-router-dom";
import { ADD_USER } from "icons";
import Icon from "components/icon";

export function EvtClientPlaceholderCard({ onClick }) {
  return (
    <Card className={classNames("h-max py-3")} onClick={onClick}>
      <CardContent>
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4 relative">
          <div className="flex items-center gap-4 flex-1">
            <div className="size-10 bg-secondary rounded-full flex place-items-center place-content-center">
              <Icon className="size-4 text-neutral-500" icon={ADD_USER} />
            </div>

            <div className="space-y-0.5">
              <h3 className="text-base text-muted-foreground leading-6 ">
                Select Client
              </h3>
              <p className="text-sm font-normal leading-5 text-muted-foreground"></p>
            </div>
          </div>

          {/* <Button
            variant="secondary"
            size="icon"
            className="h-8 w-8 rounded-full ml-auto"
            asChild
          >
            <Link to={"/crm/clients/+"}>
              <Icon icon={PLUS} />
            </Link>
          </Button> */}
        </div>
      </CardContent>
    </Card>
  );
}
